<div class="auth-message">
    <p>{{ 'auth.updateIdMessage' | translate }}</p>
</div>
<form #form
      [formGroup]='updateBoschIdForm'>

    <div class="credentials-content">
        <app-input
            [isDisabled]="inputDisabled"
            [formControl]="updateBoschIdForm.controls.identity"
            [showErrors]="showValidations"
            [placeholder]="'auth.emailLabel' | translate"
            label="{{ 'auth.emailLabel' | translate }}">
        </app-input>

        <app-input
            type="password"
            [isDisabled]="inputDisabled"
            [formControl]="updateBoschIdForm.controls.password"
            [showErrors]="showValidations"
            [placeholder]="'auth.passwordLabel' | translate"
            label="{{ 'auth.passwordLabel' | translate }}">
        </app-input>
    </div>
    <app-button (click)="onUpdateBoschID()"
                [disabled]="showValidations && !updateBoschIdForm.valid">
        {{ 'auth.buttons.send' | translate }}
    </app-button>

    <a routerLink="/auth">{{ 'auth.buttons.back' | translate }}</a>
</form>

<app-confirmation-modal
    (scanEvent)="onConfirmUpdateBoschID($event)"
    title="{{'auth.message.updateIdPopupTitle' | translate}}"
    message="{{'auth.message.updateIdPopupMessage' | translate}}">
</app-confirmation-modal>
